module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate6.5e579d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate6.png
// module id = 765
// module chunks = 0